import { useState } from 'react'
import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { useAsyncQuery } from './useAsyncQuery'

export const usePassportEvents = (userId, page = 1, pageSize = 9) => {
  const [viewingFriend, setViewingFriend] = useState(null)
  const [isOwnPassport, setIsOwnPassport] = useState(true)
  const [totalPages, setTotalPages] = useState(1)
  const [total, setTotal] = useState(0)

  // Paginated server-side. The passport used to pull every entry and slice
  // locally, which downloaded every stamp photo the user owned to show one
  // page of nine cards.
  const fetchEvents = async () => {
    const query = `page=${page}&limit=${pageSize}`

    const url = userId
      ? `${API_BASE_URL}/api/events/friend/${userId}?${query}`
      : `${API_BASE_URL}/api/events/my-events?${query}`

    setIsOwnPassport(!userId)
    if (!userId) setViewingFriend(null)

    const response = await axios.get(url, { withCredentials: true })

    const events = response.data.events || []
    setTotalPages(response.data.totalPages || 1)
    setTotal(response.data.total || events.length)

    if (userId && events.length > 0) {
      setViewingFriend(events[0].createdBy)
    }

    return events
  }

  const { data: events, loading, error, refetch: fetchEventsData } = useAsyncQuery(
    fetchEvents,
    [userId, page, pageSize],
    { initialData: [] }
  )

  const deleteEvent = async (eventId) => {
    await axios.delete(`${API_BASE_URL}/api/events/${eventId}`, {
      withCredentials: true
    })
    await fetchEventsData()
  }

  const updateDefaultPhoto = async (eventId, photoId) => {
    await axios.put(`${API_BASE_URL}/api/events/${eventId}`, {
      defaultPhoto: photoId
    }, {
      withCredentials: true
    })
    await fetchEventsData()
  }

  return {
    events,
    loading,
    error,
    viewingFriend,
    isOwnPassport,
    totalPages,
    total,
    deleteEvent,
    updateDefaultPhoto,
    refetch: fetchEventsData
  }
}
